module.exports = __webpack_public_path__ + "images/category_lp/audio_instrument/new/assessment_achievements/2_56e2551d70c3242bb25576ac54de5c51.png";